import React, { createContext, FC, ReactNode, useContext, useState } from 'react';

import { AlertColor } from '@mui/material';

import { Toast, ToastStyle } from './Toast';

export interface ToastMessage {
  message: string;
  severity: AlertColor;
  key: number;
}

// eslint-disable-next-line no-unused-vars
export const ToastContext = createContext<{ addMessage: (message: ToastMessage) => void }>(null as never);

export const DupontToastProvider: FC<{ children: ReactNode } & ToastStyle> = ({ children, ...props }) => {
  const [messages, setMessages] = useState<ToastMessage[]>([]);

  const removeMessage = (key: number) => setMessages(arr => arr.filter(m => m.key !== key));

  return (
    <ToastContext.Provider
      value={{
        addMessage(message) {
          //setMessages(arr => [...arr, message]);
          setMessages(() => [message]);
        },
      }}
    >
      {children}
      {messages.map(m => (
        <Toast key={m.key} message={m} onExited={() => removeMessage(m.key)} {...props} />
      ))}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const { addMessage } = useContext(ToastContext);

  const showToast = (message: string, severity: AlertColor) => {
    addMessage({ message, severity, key: new Date().getTime() });
  };

  return {
    showToast,
    showInfoToast(message: string) {
      showToast(message, 'info');
    },
    showSuccessToast(message: string) {
      showToast(message, 'success');
    },
    showWarningToast(message: string) {
      showToast(message, 'warning');
    },
    showErrorToast(message: string) {
      showToast(message, 'error');
    },
  };
};
